import { defineStore } from 'pinia';

export const storePreffix = 'events-platform->';
export const storeId = `${storePreffix}main`;

const useStore = defineStore('main', {
  state: () => ({
    selectedKeys: ['1'],
    openKeys: ['sub1'],
    event: {
      name: '',
      projectCode: '',
      startDate: '',
      finishDate: '',
      projectType: '',
    },
  }),
  persist: true,
  getters: {
    FORMATTED_TOKEN: (state) => state.token && `${state.token.token_type} ${state.token.access_token}`,
    done: (state) => !!state.token,
  },
});

export default useStore;
